module.exports = __webpack_public_path__ + "static/media/8.bb0b0b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/8.png
// module id = 1728
// module chunks = 0